import { ArrowRight } from 'lucide-react';

const CallToAction = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-indigo-900 via-primary to-indigo-800 text-white relative overflow-hidden">
      {/* Abstract shape background */}
      <div className="absolute inset-0 overflow-hidden opacity-20">
        <div className="absolute w-64 h-64 rounded-full bg-white/20 blur-3xl -top-10 -right-10"></div>
        <div className="absolute w-96 h-96 rounded-full bg-white/20 blur-3xl -bottom-10 -left-10"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-9">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 animate-fadeIn leading-tight">
            Ready to Transform Your Website Experience?
          </h2>
          <p className="text-xl mb-8 text-white/90 animate-fadeIn" style={{animationDelay: "0.1s"}}>
            Our support team is standing by to help you solve your website challenges and optimize your digital presence.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 animate-fadeIn" style={{animationDelay: "0.2s"}}>
            <a 
              href="/register" 
              className="inline-flex items-center justify-center px-8 py-4 rounded-lg bg-white text-primary font-medium hover:bg-opacity-95 transition-all shadow-md hover:shadow-lg hover:scale-105 group"
            >
              Get Started
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </a>
            <a 
              href="mailto:support@gravitypointmedia.com?subject=Website%20Support%20Request" 
              className="inline-flex items-center justify-center px-8 py-4 rounded-lg bg-transparent border-2 border-white font-medium hover:bg-white/10 transition-all hover:scale-105 shadow-md"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;